// extracted by mini-css-extract-plugin
export default {"container":"Bp-z","ratingLayout":"Cp-z","ratingLabel":"Dp-z","nonInteractiveRatingLabel":"Ep-z"};